import { render, staticRenderFns } from "./AppCopyField.vue?vue&type=template&id=133e04ee"
import script from "./AppCopyField.vue?vue&type=script&lang=js"
export * from "./AppCopyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports